import React, { useState } from "react";
import "./customCombobox.scss";
import { BsChevronDown, BsX } from "react-icons/bs";
import { useTranslation } from "../../../contexts/TranslationProvider";
import { BeneficialCompanyEntity, BeneficialMinorEntity, BeneficialPersonEntity } from "../../../domain/entities";

type DeepKeys<T> = {
  [K in keyof T]: T[K] extends object
  ? `${K & string}` | `${K & string}.${DeepKeys<T[K]>}`
  : `${K & string}`;
}[keyof T];
export type BeneficialField = {
  field: keyof BeneficialPersonEntity
  | keyof BeneficialCompanyEntity
  | keyof BeneficialMinorEntity
  | DeepKeys<BeneficialPersonEntity>
  ;
  label: string;
};
interface BeneficialFieldProps {
  options: BeneficialField[];
  value: BeneficialField["field"]
  onChange: (value: BeneficialField["field"]) => void;
  disabled?: boolean;
}

const BeneficialFieldCombobox = ({
  options,
  value,
  onChange,
  disabled
}: BeneficialFieldProps) => {

  const [isOpen, setIsOpen] = useState(false);
  const { language } = useTranslation();

  const handleOptionClick = (option) => {
    setIsOpen(false);
    onChange(option.field);
  };

  const handleDropdownClick = (event) => {
    event.stopPropagation(); // Add this line to stop event propagation
    setIsOpen(!isOpen);
    if (!isOpen) {
    }
  };

  const handleClearClick = (event) => {
    event.stopPropagation(); // Add this line to stop event propagation
    onChange(null);
  };

  const currentOptionDisplay = options.find(option => option.field === value)?.label;

  return (
    <div className="param-type-container">
      <div className="custom-combobox">
        <div className="param-type-selected" onClick={handleDropdownClick}>
          {currentOptionDisplay}
          <span className={`param-type-actions ${language == "ar" && "arabic-display"}`}>
            {!isOpen && value && !disabled && (
              <BsX
                color="#ff0000" // Set the color for the X icon
                onClick={handleClearClick}
              />
            )}
            <BsChevronDown color={!disabled ? "#2f14e5" : "gray"} />
          </span>
        </div>
        {isOpen && !disabled && (
          <div className="param-type-options">
            {options.map((option, index) => {
              const key = `_${index}`;
              const display = option.label;
              return (
                <div key={key} className={"param-type-option"} onClick={() => handleOptionClick(option)}>
                  {display}
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default BeneficialFieldCombobox;
